module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container1"
  }, [_c('el-col', {
    staticClass: "main1",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "content-container1"
  }, [_c('el-breadcrumb', {
    staticClass: "navTop",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.realList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2a8d22a9"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 594
// module chunks = 70